import { FmlxBanner } from 'fmlx-common-ui';
import React from 'react';

export const SearchResultInfoPanel = () => {
  return (
    <div id="searchresultinfopanel-wrapper" className="p-4">
      <FmlxBanner
        variant={FmlxBanner.Variant.INFO}
        title={'Currently in Searching Mode'}
        subtitle={'Select any file to get more information'}
        hideCloseButton
      />
    </div>
  );
};
